/**
 * created by li si yi
 * 稿件与网站稿件待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";

class WebStoryEditor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};
    getMediaNewIds = (data) => {
        let ids = [];
        if (data.activitiCategoryKey !== "tggj") {
            ids.push(data.data.id);
        }
        return ids;
    };

    isSupport(data, callback) {
        this.data = data;
        let mediaNewIds = this.getMediaNewIds(this.data);
        if (this.data && this.data.data && this.data.data.id && mediaNewIds.length && this.data.activitiCategoryKey === "storyToWebNews") {
            this.activitiDataConvertReceiveInfoByMediaNews(mediaNewIds, (res) => {
                let status = false;
                if (res && res.length && res[0] && res[0].mediaIds && res[0].mediaIds.length) {
                    let mediaIds = res[0].mediaIds;
                    let currentDeptId = window.currentUser.defaultInfo.dept.id;
                    //获取当前部门的所有媒体  双循环媒体id(mediaIds,currentDeptId)  没有交集为 true
                    //请求媒体
                    this.getMediaByDeptId(currentDeptId, (mediaList) => {
                        let currentDeptMedias = [];
                        if (mediaList && mediaList.length) {
                            currentDeptMedias = mediaList;
                        }
                        status = mediaIds.every(mediaId => currentDeptMedias.every(currentDeptMedia => currentDeptMedia.id !== mediaId));
                        callback && callback(status);
                    });
                } else {
                    callback && callback(status);
                }
            });
        } else {
            return false;
        }
    };
    getIcon = (data) => {
        let icon = 'ContributeIcon';
        return icon
    };
    handle = (data, call) => {
        window.openEditById({
            configName: data.data.openEditorStyle ? data.data.openEditorStyle : "webStoryEditor",
            id: data.data.id
        });
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                call && call();
            }
        }, "ManuscriptsSubmitted")
    };

    activitiDataConvertReceiveInfoByMediaNews = (ids, callBack) => {
        this.request({
            url: "/cm-sites-pms/story/contribute/getReceiveInfoByMediaNews",
            body: {ids}, callBack
        });
    };
    // 获取当前用户下所有媒体
    getMediaByDeptId = (deptId, callBack) => {
        this.request({
            url: "/cm-sites-pms/media/getMediaByDept",
            body: {deptId: deptId}, callBack
        });
    };

    render() {
        return (
            <div style={{display: 'none'}}>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(WebStoryEditor)